import Entity from '../entity'

export default class Manufacturer extends Entity<number>{
    name: string;
    active: boolean;
}


